export default function CTASection() {
  return (
    <section className="py-28 relative overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(135deg, #0e0e1a 0%, #141420 50%, #0e0e1a 100%)',
        }}
      />
      {/* Gold glow */}
      <div className="absolute inset-0 pointer-events-none flex items-center justify-center">
        <div className="w-[700px] h-[400px] rounded-full opacity-15" style={{ background: 'radial-gradient(ellipse, #c9a84c 0%, transparent 70%)' }} />
      </div>
      {/* Grid pattern overlay */}
      <div
        className="absolute inset-0 opacity-5 pointer-events-none"
        style={{
          backgroundImage: 'linear-gradient(rgba(201,168,76,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(201,168,76,0.4) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8 relative z-10">
        <span className="inline-block text-xs font-semibold tracking-[0.25em] uppercase mb-6" style={{ color: '#c9a84c' }}>
          Take the Next Step
        </span>
        <h2 className="text-4xl md:text-5xl font-light text-white mb-6 leading-tight tracking-tight">
          Ready to Engineer{' '}
          <span style={{ background: 'linear-gradient(135deg, #c9a84c, #f0d98a)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: 700 }}>
            Brilliance
          </span>{' '}
          Into Your Organization?
        </h2>
        <p className="text-lg text-white/50 mb-12 font-light leading-relaxed max-w-2xl mx-auto">
          Transform your organization with AI-powered strategic consulting across Digital Biology, Digital Transformation, and Digital Wellness. From drug discovery and clinical optimization to intelligent automation and evidence-based wellness — we guide your journey to luminous innovation.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="#contact"
            className="px-8 py-4 text-base font-semibold whitespace-nowrap cursor-pointer transition-all duration-300 text-center tracking-wide hover:opacity-90"
            style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c87a)', color: '#09090f', borderRadius: '4px' }}
          >
            Start Your Transformation
          </a>
          <a
            href="#services"
            className="px-8 py-4 text-base font-medium whitespace-nowrap cursor-pointer transition-all duration-300 text-center tracking-wide text-white/75 hover:text-[#c9a84c]"
            style={{ border: '1px solid rgba(201,168,76,0.3)', background: 'rgba(201,168,76,0.05)', borderRadius: '4px' }}
          >
            Explore Our Solutions
          </a>
        </div>
      </div>
    </section>
  );
}
